import { environment } from '../environments/environment';
import { CommonConverter } from './common.converter';

export class VisualizacaoEdicaoUtils {
  static deveExibirHtml(data: Date): boolean {
    return CommonConverter.formatDateToString(data) >= environment.dataInicioVisualizacaoHtml;
  }
}
